import { TextDisplayBlock as TextDisplayBlockType } from '../../types/blueprint'
import { Unanswered } from '../DisplayBlock.style'

import { Text } from '@/components/shared-components/BUI/Text'
import { TextWithHyperlinks } from '@/components/shared-components/TextWithHyperlinks'

type Props = {
  block: TextDisplayBlockType
}

export const TextDisplayBlock: React.FC<Props> = ({ block }) => {
  const { content } = block

  if (!content) return <Unanswered />

  return (
    <Text>
      <TextWithHyperlinks content={content} whiteSpace="pre-wrap" />
    </Text>
  )
}
